import { useMutation } from '@apollo/client'
import { ToggleUserMarketing, ToggleUserMarketingVariables } from '../../types'
import { TOGGLE_USER_MARKETING } from './operations'

export const useToggleUserMarketing = () =>
  useMutation<ToggleUserMarketing, ToggleUserMarketingVariables>(TOGGLE_USER_MARKETING)
